import { createVNode as _createVNode } from "vue";
import { resolveComponent as _resolveComponent } from "vue";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _IpWhitelistSettings;
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.some.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
var IpWhitelistSettings_1;
import { __decorate } from "tslib";
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ref } from "vue";
import { TableV2SortOrder } from "element-plus";
import WTextInput from "@/components/wrapper/w-text-input.vue";
import WLabel from "@/components/wrapper/w-label.vue";
import WStandardButton from "@/components/wrapper/w-standard-button.vue";
import WIcon from "@/components/wrapper/w-icon.vue";
import ConfirmDialog from "@/components/dialog/ConfirmDialog.vue";
import store from "@/store";
import { ADD_WHITELISTED_IP, IMPORT_WHITELISTED_IPS, REMOVE_ALL_WHITELISTED_IP, REMOVE_WHITELISTED_IP, RESET_WHITELISTED_IPS_SEARCH_PARAMS, SEARCH_WHITELISTED_IPS } from "@/store/actions/ipWhitelist";
import Banner from "@/components/banner/Banner.vue";
import MessagesUtil from "@/utils/messagesUtil";
import { isValidPublicIPV4Address } from "@/utils/util";
import WEmpty from "@/components/wrapper/w-empty.vue";
import { SEARCH_WHITELISTED_IP_PAGE_SIZE } from "@/store/modules/ipWhitelist";
var IpWhitelistSettings = IpWhitelistSettings_1 = (_IpWhitelistSettings = /*#__PURE__*/function (_Vue) {
  function IpWhitelistSettings() {
    var _this;
    _classCallCheck(this, IpWhitelistSettings);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, IpWhitelistSettings, [].concat(args));
    _defineProperty(_this, "platformID", void 0);
    _defineProperty(_this, "ipAddressInputValue", '');
    _defineProperty(_this, "displayDeleteConfirmationDialog", false);
    _defineProperty(_this, "ipToDelete", void 0);
    _defineProperty(_this, "deleteDialogTitle", void 0);
    _defineProperty(_this, "ipDeleteDialogMessageCustomPath", void 0);
    _defineProperty(_this, "uploadInProgress", false);
    _defineProperty(_this, "loading", false);
    _defineProperty(_this, "currentPage", 0);
    _defineProperty(_this, "currentLastVisibleRowIdx", 0);
    _defineProperty(_this, "errorMsg", '');
    _defineProperty(_this, "upload", ref());
    _defineProperty(_this, "sortState", {
      key: IpWhitelistSettings_1.ADDED_ON_KEY,
      order: TableV2SortOrder.ASC
    });
    return _this;
  }
  _inherits(IpWhitelistSettings, _Vue);
  return _createClass(IpWhitelistSettings, [{
    key: "whitelistedIpAddress",
    get: function get() {
      return store.getters.whitelistedIps;
    }
  }, {
    key: "columns",
    get: function get() {
      var _this2 = this;
      return [{
        key: IpWhitelistSettings_1.IP_ADDRESS_KEY,
        title: "".concat(this.$t('platform_detail.ip_whitelisting_view.ip_tables.columns.whitelisted_ips').toString(), " (").concat(this.totalIps, ")"),
        dataKey: 'ipAddress',
        width: 510
      }, {
        key: IpWhitelistSettings_1.ADDED_ON_KEY,
        title: this.$t('platform_detail.ip_whitelisting_view.ip_tables.columns.added_on').toString(),
        dataKey: 'addedOn',
        width: 510,
        sortable: true
      }, {
        key: 'actions',
        width: 510,
        align: 'right',
        cellRenderer: function cellRenderer(_ref) {
          var rowData = _ref.rowData;
          var onClick = function onClick() {
            _this2.removeIp(rowData);
          };
          return _createVNode(_resolveComponent("w-icon-button"), {
            "iconClass": "delete-outline",
            "class": "remove-ip-btn",
            "onClick": onClick
          }, null);
        }
      }];
    }
  }, {
    key: "created",
    value: function created() {
      store.dispatch(RESET_WHITELISTED_IPS_SEARCH_PARAMS);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.loadWhitelistedIps();
    }
  }, {
    key: "totalIps",
    get: function get() {
      return store.getters.totalIps;
    }
  }, {
    key: "loadWhitelistedIps",
    value: function loadWhitelistedIps() {
      var _this3 = this;
      this.loading = true;
      store.dispatch(SEARCH_WHITELISTED_IPS, {
        platformID: this.platformID,
        searchIp: this.ipAddressInputValue,
        page: this.currentPage + 1,
        asc: this.sortState.order === TableV2SortOrder.ASC
      }).then(function () {
        _this3.currentPage++;
      }).catch(function (err) {
        return _this3.errorMsg = err;
      }).finally(function () {
        return _this3.loading = false;
      });
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(value) {
      this.ipAddressInputValue = value === null || value === void 0 ? void 0 : value.trim();
      this.reloadWhitelistedIps();
    }
  }, {
    key: "reloadWhitelistedIps",
    value: function reloadWhitelistedIps() {
      this.currentPage = 0;
      store.dispatch(RESET_WHITELISTED_IPS_SEARCH_PARAMS);
      this.loadWhitelistedIps();
    }
  }, {
    key: "onSort",
    value: function onSort(_ref2) {
      var key = _ref2.key,
        order = _ref2.order;
      this.sortState = {
        key: key,
        order: order
      };
      this.reloadWhitelistedIps();
    }
  }, {
    key: "onRowRendered",
    value: function onRowRendered($event) {
      if (this.currentLastVisibleRowIdx === $event.rowVisibleEnd) {
        return;
      } else {
        this.currentLastVisibleRowIdx = $event.rowVisibleEnd;
      }
      if (this.shouldSilentlyLoadMoreData(this.currentLastVisibleRowIdx)) {
        if (this.whitelistedIpAddress.length < this.totalIps) {
          this.loadWhitelistedIps();
        }
      }
    }
  }, {
    key: "shouldSilentlyLoadMoreData",
    value: function shouldSilentlyLoadMoreData(currentLastVisibleRowIdx) {
      return this.whitelistedIpAddress.length - currentLastVisibleRowIdx < IpWhitelistSettings_1.NB_ROW_BEFORE_REFRESH && !this.loading;
    }
  }, {
    key: "addNewIpAddress",
    value: function addNewIpAddress() {
      var _this4 = this;
      if (this.doesMatchRequirements(this.ipAddressInputValue)) {
        this.loading = true;
        store.dispatch(ADD_WHITELISTED_IP, {
          ipAddress: this.ipAddressInputValue,
          platformID: this.platformID
        }).then(function () {
          _this4.ipAddressInputValue = '';
          MessagesUtil.showSuccessMessage(_this4.$t('platform_detail.ip_whitelisting_view.toast_msg.ip_add_success').toString());
          _this4.reloadWhitelistedIps();
          _this4.errorMsg = '';
        }).catch(function (err) {
          _this4.errorMsg = err;
        }).finally(function () {
          return _this4.loading = false;
        });
      }
    }
  }, {
    key: "downloadAllIpAddresses",
    value: function downloadAllIpAddresses() {
      if (this.whitelistedIpAddress.length > 0) {
        var csvData = this.whitelistedIpAddress.map(function (_ref3) {
          var ipAddress = _ref3.ipAddress;
          return ipAddress;
        });
        var csvContent = csvData.join('\n');
        var blob = new Blob([csvContent], {
          type: 'text/csv;charset=utf-8;'
        });
        var link = document.createElement('a');
        var url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', 'whitelisted_ip_addresses-' + this.platformID + '.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }, {
    key: "deleteAllIpsAddress",
    value: function deleteAllIpsAddress() {
      this.ipToDelete = null;
      this.deleteDialogTitle = this.$t('platform_detail.ip_whitelisting_view.all_ip_delete_dialog.title');
      this.ipDeleteDialogMessageCustomPath = 'all_ip_delete_dialog';
      this.displayDeleteConfirmationDialog = true;
    }
  }, {
    key: "onFileSelected",
    value: function onFileSelected(fileData) {
      var file = fileData.raw;
      var reader = new FileReader();
      reader.onloadend = this.batchImportIpsAddress;
      reader.readAsDataURL(file);
    }
  }, {
    key: "batchImportIpsAddress",
    value: function batchImportIpsAddress(e) {
      var _this5 = this;
      var fileUrl = e.target.result;
      this.uploadInProgress = true;
      store.dispatch(IMPORT_WHITELISTED_IPS, {
        fileUrl: fileUrl,
        platformID: this.platformID
      }).then(function () {
        MessagesUtil.showSuccessMessage(_this5.$t('platform_detail.ip_whitelisting_view.toast_msg.ip_batch_add_success').toString());
        _this5.reloadWhitelistedIps();
        _this5.errorMsg = '';
      }).catch(function (err) {
        _this5.errorMsg = err;
      }).finally(function () {
        return _this5.uploadInProgress = false;
      });
    }
  }, {
    key: "removeIp",
    value: function removeIp(whitelistedIp) {
      this.ipToDelete = whitelistedIp;
      this.deleteDialogTitle = this.$t('platform_detail.ip_whitelisting_view.single_ip_delete_dialog.title');
      this.ipDeleteDialogMessageCustomPath = 'single_ip_delete_dialog';
      this.displayDeleteConfirmationDialog = true;
    }
  }, {
    key: "doConfirmDelete",
    value: function doConfirmDelete() {
      var _this6 = this;
      this.loading = true;
      if (this.ipToDelete) {
        store.dispatch(REMOVE_WHITELISTED_IP, {
          ipId: this.ipToDelete.id,
          platformID: this.platformID
        }).then(function () {
          MessagesUtil.showSuccessMessage(_this6.$t('platform_detail.ip_whitelisting_view.toast_msg.ip_delete_success').toString());
          _this6.errorMsg = '';
          if (_this6.whitelistedIpAddress.length < SEARCH_WHITELISTED_IP_PAGE_SIZE && _this6.whitelistedIpAddress.length < _this6.totalIps) {
            _this6.loadWhitelistedIps();
          }
        }).catch(function (err) {
          _this6.errorMsg = err;
        }).finally(function () {
          return _this6.loading = false;
        });
      } else {
        store.dispatch(REMOVE_ALL_WHITELISTED_IP, this.platformID).then(function () {
          MessagesUtil.showSuccessMessage(_this6.$t('platform_detail.ip_whitelisting_view.toast_msg.ip_delete_all_success').toString());
          _this6.errorMsg = '';
        }).catch(function (err) {
          _this6.errorMsg = err;
        }).finally(function () {
          return _this6.loading = false;
        });
      }
    }
  }, {
    key: "doCancelDelete",
    value: function doCancelDelete() {
      this.displayDeleteConfirmationDialog = false;
      this.ipToDelete = null;
      this.deleteDialogTitle = '';
      this.ipDeleteDialogMessageCustomPath = '';
    }
  }, {
    key: "doesMatchRequirements",
    value: function doesMatchRequirements(ipAddres) {
      return this.isNotWhitelisted(ipAddres) && this.isValidIpAddress(ipAddres);
    }
  }, {
    key: "isValidIpAddress",
    value: function isValidIpAddress(ipAddress) {
      if (!isValidPublicIPV4Address(ipAddress)) {
        MessagesUtil.showErrorMessage(this.$t('platform_detail.ip_whitelisting_view.toast_msg.ip_invalid_error').toString());
        return false;
      }
      return true;
    }
  }, {
    key: "isNotWhitelisted",
    value: function isNotWhitelisted(ipAddress) {
      if (this.whitelistedIpAddress.some(function (w) {
        return w.ipAddress === ipAddress;
      })) {
        MessagesUtil.showErrorMessage(this.$t('platform_detail.ip_whitelisting_view.toast_msg.ip_already_whitelisted_error').toString());
        return false;
      }
      return true;
    }
  }]);
}(Vue), _defineProperty(_IpWhitelistSettings, "IP_ADDRESS_KEY", 'IP_ADDRESS'), _defineProperty(_IpWhitelistSettings, "ADDED_ON_KEY", 'ADDED_ON_KEY'), _defineProperty(_IpWhitelistSettings, "NB_ROW_BEFORE_REFRESH", 8), _IpWhitelistSettings);
__decorate([Prop()], IpWhitelistSettings.prototype, "platformID", void 0);
IpWhitelistSettings = IpWhitelistSettings_1 = __decorate([Options({
  components: {
    WEmpty: WEmpty,
    Banner: Banner,
    ConfirmDialog: ConfirmDialog,
    WIcon: WIcon,
    WStandardButton: WStandardButton,
    WLabel: WLabel,
    WTextInput: WTextInput
  }
})], IpWhitelistSettings);
export default IpWhitelistSettings;